var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"facebook-sign-in-button",class:{disabled: _vm.disabled},on:{"click":_vm.facebookSignIn}},[_c('facebook-icon'),_c('div',{staticClass:"text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }